export default __webpack_public_path__ + "7cc73202a71222365c8b55479711d8af.svg";